import ApiGetOptions from '@/datatypes/api-get-options';
import ApiPostOptions from '@/datatypes/api-post-options';
import ApiDeleteOptions from '@/datatypes/api-delete-options';
import ApiService from '@/services/api/ApiService';

export default class DocumentService extends ApiService {
  public getDocument(documentId) {
    return this.call(new ApiGetOptions(
      {
        url: `/documents/${documentId}`,
      },
    ));
  }

  public getDocumentEvents(documentId) {
    return this.call(new ApiGetOptions(
      {
        url: `/documents/${documentId}/events`,
      },
    ));
  }

  public deleteDocument(documentId) {
    return this.call(new ApiDeleteOptions(
      {
        url: `/documents/${documentId}`,
      },
    ));
  }

  public verifyDocument(documentId) {
    return this.call(new ApiPostOptions(
      {
        url: `/documents/${documentId}/verification`,
      },
    ));
  }
}
